import React from "react";
import { Badge, Tag, Tooltip } from "antd";

/**
 * Markering "Uitlopend" (BMX-49): Bombyxx heeft besloten dit product uit het assortiment te
 * halen, dus het hoort niet opnieuw besteld te worden.
 *
 * Eén component voor alle plekken waar die markering staat, zodat kleur en woordkeuze niet op
 * vier schermen apart onderhouden worden. Het is bewust alléén een signaal: bestellen blijft
 * gewoon mogelijk (er is een legitieme laatste bestelling), volgens hetzelfde
 * "waarschuwen in plaats van blokkeren"-patroon als de rest van het inkoopproces.
 *
 * Twee vormen, omdat de kolommen verschillen:
 * - `variant="badge"` hangt een stip op de productfoto. Voor kolommen met een `AvatarStatus`
 *   (productenlijst, voorraadoverzicht); een tag naast een foto van 60px verspringt de rij.
 * - `variant="tag"` zet een tag naast de naam. Voor kolommen zonder foto (inkooporder
 *   aanmaken, inkooporder detail).
 */
const LABEL = "Uitlopend";
const TOOLTIP = "Uitlopend";
const COLOR = "#fa8c16";

const DiscontinuedMark = ({ discontinued, variant = "tag", children }) => {
  if (!discontinued) return children ?? null;

  if (variant === "badge") {
    return (
      <Tooltip title={TOOLTIP}>
        <Badge dot color={COLOR} offset={[-6, 4]}>
          {children}
        </Badge>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={TOOLTIP}>
      <Tag color="orange" style={{ marginInlineEnd: 0 }}>
        {LABEL}
      </Tag>
    </Tooltip>
  );
};

export default DiscontinuedMark;
